import {Button, Modal, Space, Table} from 'antd'
import { useEffect, useState} from "react";
import service from "../../../@services";
import QueryString from "qs";

export default function HistoryList(props){
    const {visible,actId,storeCode,close=()=>{}} = props
    const [loading, setLoading] = useState(false)
    const [tableData, setTableData] = useState([])
    const [pagination, setPagination] = useState({current: 1,pageSize: 10,})
    useEffect(() => {
        actId && getDetailList()
    }, [visible]);

    const getDetailList = async () =>{
        const params = {
            skuId: actId,
            storeCode: storeCode,
            ...pagination
        }
        setLoading(true)
        const data = await service.inventory.getonlineList(params)
        setLoading(false)
        if(data){
            setTableData(data.result)
            setPagination({
                current: data.pageIndex,
                pageSize: data.pageSize,
                total: data.length
            })
        }
    }

    const handleTableChange = (pagination) => {
        setPagination(pagination)
    }

    const columns = [
        {
            title: '序号',
            dataIndex: '',
            key: 'index',
            width: '80px',
            render: (text,record,index)=> index+1 },
        {
            title: '操作描述',
            dataIndex: 'operDesc'
        },
        {
            title: '操作人',
            dataIndex: 'operName',
        },
        {
            title: '操作时间',
            dataIndex: 'operTime',
        }
    ]

    return(
        <Modal
            title="修改记录"
            visible={visible}
            onCancel={close}
            footer={false}
            width={'680px'}
        >
            <Table
                rowKey={index=>index}
                dataSource={tableData}
                pagination={pagination}
                loading={loading}
                columns={columns}
                onChange={handleTableChange}
            />
        </Modal>
    )
}
